import React, { useState } from "react";
import { Row, Col, FormGroup, Label, Input, Button, Card, CardBody } from "reactstrap";
import axiosInstance from "../../request";
import { URL } from "../../api";

const RecurringReporting = () => {
  const [customerId, setCustomerId] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    try {
      setLoading(true);

      const params = {};
      if (customerId) params.customerId = customerId;
      if (fromDate) params.fromDate = fromDate;
      if (toDate) params.toDate = toDate;

      // API Hit - responseType 'blob' file download ke liye zaroori hai
      const response = await axiosInstance.get(URL.RECURRING_EXCEL, {
        params,
        responseType: "blob", 
      });

      // Blob creation for CSV/Excel download
      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      
      // Temporary link create karke click karwana
      const link = document.createElement("a");
      link.href = url;
      
      // File name formatting
      const fileName = `Recurring_Mandate_Report_${new Date().toISOString().split('T')[0]}.csv`;
      link.setAttribute("download", fileName);
      
      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error("Export Error:", error);
      alert("Report download failed.");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setCustomerId("");
    setFromDate("");
    setToDate("");
  };

  return (
    <Card className="shadow-sm border-0 mt-3">
      <CardBody>
        <h5 className="text-muted mb-4">Search & Export Mandate Executions</h5>
        <Row className="align-items-end">
          <Col md="3">
            <FormGroup>
              <Label for="custId" className="small fw-bold">Customer ID</Label>
              <Input
                type="number"
                id="custId"
                placeholder="cust id"
                value={customerId}
                onChange={(e) => setCustomerId(e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <Label for="fDate" className="small fw-bold">From Date</Label>
              <Input
                type="date"
                id="fDate"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <Label for="tDate" className="small fw-bold">To Date</Label>
              <Input
                type="date"
                id="tDate"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md="3" className="mb-3">
            <div className="d-flex gap-2">
              <Button 
                color="primary" 
                block 
                onClick={handleDownload} 
                disabled={loading}
              >
                {loading ? (
                  <><i className="fas fa-spinner fa-spin me-2"></i>Exporting...</>
                ) : (
                  <><i className="fas fa-file-excel me-2"></i>Excel</>
                )}
              </Button>
            </div>
          </Col>
        </Row>
        <div className="mt-2 text-muted small">
          <i className="fas fa-info-circle me-1"></i>
        </div>
      </CardBody>
    </Card>
  );
};
export default RecurringReporting;